import {SET} from './constants';

export const show = (vehicle) => ({
  type: SET,
  data: {visible: true, vehicle},
});

export const hide = () => ({
  type: SET,
  data: {visible: false},
});
